import Icon from "@utilities/Icon"
import { useId } from "@utilities/useId"
import classNames from "classnames"
import * as React from "react"

interface InputTextBaseProps {
  children: (props: {
    descriptionId?: string
    inputId: string
  }) => React.ReactNode
  description?: string
  hideLabel?: boolean
  id?: string
  invalid?: boolean
  label?: React.ReactNode
  size?: "md" | "lg"
}

export type InputTextBaseElementProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  keyof InputTextBaseProps
> &
  InputTextBaseProps

export function InputTextBase({
  children,
  className,
  description,
  hideLabel,
  id,
  label,
  invalid,
  size,
}: InputTextBaseElementProps) {
  const combinedClassName = classNames("tds-input", className, {
    "tds-input--invalid": invalid,
    "tds-input--lg": size === "lg",
  })

  const stableId = useId()
  const inputId = id || `tds-input-${stableId}`
  const resolvedDescription =
    description || (invalid ? "This field is required" : undefined)
  const descriptionId = resolvedDescription
    ? `${inputId}-description`
    : undefined

  return (
    <div className={combinedClassName}>
      {!hideLabel && label ? <label htmlFor={inputId}>{label}</label> : null}
      {children({
        descriptionId,
        inputId,
      })}
      {resolvedDescription && (
        <p id={descriptionId} className="tds-input-description">
          <Icon
            className="tds-input-description-invalid-icon"
            symbol="general#exclamation-triangle"
            aria-hidden
          />
          {resolvedDescription}
        </p>
      )}
    </div>
  )
}
